import { createContext, useContext } from "react";

/** What the standalone bar's host decides about next-prompt ghosts. */
export interface StandaloneBarPredictionScope {
  /** False while a host scripts the bar (the onboarding demo), shows a worker's
   *  question card, or has a blocked worker bar. Transient disables (closing,
   *  sending) keep it true, so the ghost stays put. */
  enabled: boolean;
}

/** Provided by InputBarTargetComposer. An InputBar rendered directly (fixtures,
 *  tests) gets the default. Lets the flag skip input-bar.tsx, which is at its
 *  line budget. */
export const StandaloneBarPredictionContext = createContext<StandaloneBarPredictionScope>({
  enabled: true,
});

export function useStandaloneBarPredictionScope(): StandaloneBarPredictionScope {
  return useContext(StandaloneBarPredictionContext);
}
